import { MutableRefObject, useEffect, useRef, useState } from 'react'

// eslint-disable-next-line no-restricted-imports
import { Column } from '@ag-grid-community/core'
import { Icon, Text } from '@joor/design-system'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;
  height: 39px;

  & .customHeaderMenuButton {
    visibility: hidden;
  }

  &:hover .customHeaderMenuButton {
    visibility: visible;
  }
`

const WrappedMenuIcon = styled(Icon)`
  transform: scale(0.9);
`

const TextWithIcon = styled.div`
  display: flex;
  gap: 4px;
`

const SortIcon = styled(Icon)`
  transform: scale(0.65, 0.9);
  svg {
    --main-color: var(--color-primary-400);
  }
`

const FilterIcon = styled(Icon)`
  transform-origin: top center;
  transform: scale(-1, 0.78);

  svg {
    --main-color: var(--color-primary-400);
  }
`

interface CustomMenuProps {
  showColumnMenu: (menu: MutableRefObject<null>) => void
}

const CustomMenu = ({ showColumnMenu }: CustomMenuProps) => {
  const refButton = useRef(null)

  const onMenuClicked = () => {
    showColumnMenu(refButton.current!)
  }
  return (
    <div
      ref={refButton}
      className="customHeaderMenuButton"
      onClick={() => onMenuClicked()}
    >
      <WrappedMenuIcon
        iconName="menu"
        iconSize="small"
        variant="INACTIVE"
        plain
      />
    </div>
  )
}

interface DueDateHeaderProps {
  displayName: string
  enableMenu: boolean
  showColumnMenu: (button: MutableRefObject<null>) => void
  column: Column
  progressSort: () => void
}

export const DueDateHeader = ({
  displayName,
  enableMenu,
  column,
  progressSort,
  showColumnMenu,
}: DueDateHeaderProps) => {
  const [ascSort, setAscSort] = useState(false)
  const [descSort, setDescSort] = useState(false)

  const handleSorting = () => {
    progressSort()
  }
  const onSortChanged = () => {
    const sort = column.getSort()
    setAscSort(sort === 'asc')
    setDescSort(sort === 'desc')
  }

  useEffect(() => {
    column.addEventListener('sortChanged', onSortChanged)
    return () => {
      column.removeEventListener('sortChanged', onSortChanged)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container>
      {enableMenu && <CustomMenu showColumnMenu={showColumnMenu} />}
      <TextWithIcon onClick={handleSorting}>
        {ascSort && <SortIcon iconName="arrow-up" iconSize="small" plain />}
        {descSort && <SortIcon iconName="arrow-down" iconSize="small" plain />}
        <Text
          fontSize="small"
          fontWeight="semibold"
          color="primary-500"
          letterSpacing="tighter"
        >
          {displayName}
        </Text>
        <Icon iconName="information" iconSize="small" variant="ACTIVE" />
        {column.isFilterActive() && (
          <FilterIcon iconName="sort" iconSize="small" plain />
        )}
      </TextWithIcon>
    </Container>
  )
}
